import apicalls from '../api/apiCalls';
const SET_TRANSACTION_GRID_DATA = 'getTransactionData';

const getTransactionData = (payload) => {
    return {
        type: SET_TRANSACTION_GRID_DATA,
        payload
    }
};

const fetchTransactionDetails = (id,pageNo,pageSize) => {
    return async (dispatch) => {
        dispatch(getTransactionData({ key: "transactioListData", loading: true, data: null }));
        const response = await apicalls.getOrderHistoryGrid(id,pageNo,pageSize);
        if (response.ok) {
            dispatch(getTransactionData({ key: "transactioListData", loading: false, data: response.data }));
        } else {
            dispatch(getTransactionData({ key: "transactioListData", loading: false, data: null, error: response.originalError.message }));
        }
    }
}

let initialState = {
    transactioListData: {loading: false, data: [],error:null}
}
let TransactionGridReducer = (state , action) => {
    if(!state){
        state={...initialState,...state}
      }
    switch (action.type) {
        case SET_TRANSACTION_GRID_DATA:
            state = { ...state, [action.payload.key]: { ...state[action.payload.key], ...action.payload } };
            return state;
       
        default:
            return state;
    }
}
export default TransactionGridReducer;
export {getTransactionData,fetchTransactionDetails  }
